"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ProteusError = (function (_super) {
    __extends(ProteusError, _super);
    function ProteusError(message, code) {
        if (code === void 0) { code = 1; }
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.code = code;
        Object.setPrototypeOf(_this, ProteusError.prototype);
        _this.code = code;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    ProteusError.CODE = {
        CASE_100: 100,
        CASE_101: 101,
        CASE_102: 102,
        CASE_103: 103,
        CASE_104: 104,
    };
    return ProteusError;
}(Error));
exports.default = ProteusError;
//# sourceMappingURL=ProteusError.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/errors/ProteusError.js
// module id = 16
// module chunks = 0 1